import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy, isDevMode } from '@angular/core'
import { ViewService, HttpService, NatsService } from '../shared'
import { Subscription, Subject } from 'rxjs'
import { Collection } from '../model/collection'
import { saveAs } from 'file-saver';
import { SocketService } from '../shared/socket.service';
import { deepCopy } from 'deep-copy-ts'
import { WebsocketService } from '../shared/websocket.service';

declare var DFK: any;

@Component({
	selector: 'preview',
	template: require('./preview.component.html'),
	styles: [require('./preview.component.scss'), require('../app.component.scss')],
	providers: [NatsService, SocketService, WebsocketService]
})

export class PreviewComponent implements OnInit, OnDestroy {

	@Output() closePreview = new EventEmitter();
	@Input() collection: Collection;
	@ViewChild('csvpreview') csv_preview;
	@ViewChild('xlspreview') xls_preview;
	export_result: any = '';
	busy: Subscription;
	showIndicator = false;
	progressSubscription: Subscription;
	resultLinkSubscription: Subscription;
	progress = 'Page ';
	resultLink = '';
	requestCount = 0;
	responseCount = 0;
	elapsedTime = '';
	counter = 1;
	currentProcessID = '';
	userLoggedIn = false;
	dashboardURL = '';

	private outputFormat = 'csv';

	constructor(private _httpService: HttpService,
		private _viewService: ViewService,
		private _natsService: NatsService,
		private wsService: WebsocketService,
		private sockerService: SocketService) {
		if (isDevMode()) {
			this.dashboardURL = 'http://localhost:8005/tasks';
		} else {
			this.dashboardURL = 'https://account.dataflowkit.com/tasks';
		}
	}

	ngOnInit() {
		this.busy = null;
		this.progressSubscription = this.sockerService.progressMessage$.subscribe(message => this.progress = message);
		this.resultLinkSubscription = this.sockerService.resultLink$.subscribe(pr => {
			if (pr !== '') {
				let parseResult = JSON.parse(pr);
				this._viewService.resultAlert(parseResult);
				if (parseResult.results !== '') {
					this.resultLink = parseResult.results;
				}
				/* this.requestCount = parseResult.Requests.initial;
				this.responseCount = parseResult['Responses'];
				this.elapsedTime = parseResult['Took']; */
			}
		});
	}

	update(collection?: Collection) {
		if (collection !== undefined) {
			this.collection = collection;
			if (collection.format !== 'xlsx') {
				this.outputFormat = collection.format;
			} else {
				this.outputFormat = 'csv';
			}
		}
		this.onExport(this.outputFormat, true);
	}

	onClose() {
		this.closePreview.emit();
	}

	onExport(format: string, preview: boolean) {
		// this.outputFormat = format.toLocaleLowerCase();
		this.collection.preview = preview;
		if (preview) {
			this.export_result = '';
		}
		this.counter = 0;
		this.progress = 'Initializing...';
		let previewCollection: any = new Collection('preview', null, null);
		previewCollection = deepCopy(this.collection);
		previewCollection.__proto__ = Collection.prototype;
		previewCollection.format = format;
		let payload = previewCollection.stringify(format, this.collection.name);
		this._viewService.enableUI = false;
		this._viewService.isSelecting = true;
		this._httpService.postCollection(payload).subscribe(
			response => this.responseHandler(format, response),
			err => this.onError(err)
		);
		// this.responseHandler('json', {'id': 'some_id'});
		/* this.sockerService.connect();
		let parse = this._natsService.parse(payload);
		this.showIndicator = true;
		this._viewService.enableUI = false;
		this.busy = parse.subscribe(
			parse_res => this.updateResult(format, parse_res),
			err => this.onError(err),
			() => this.onFinish()
		); */

		/*this.export_result = '';
		this.busy = this._httpService.postCollection(this._selectorService.getCollectionByName(this.collectionName)
		.stringify(format, this.collectionName))
		.subscribe(res => this.updateResult(format, res),
					error => this._viewService.errorAlert(error),
					() => console.log('post data finished'));*/
	}

	responseHandler(format: string, response: any) {
		this.currentProcessID = response.id;
		/* this.busy = this.sockerService.connect1(response.id).subscribe(
			parse_res => this.updateResult(format, parse_res),
			err => this.onError(err),
			() => this.onFinish()
		); */
		this.busy = this.wsService.connect(this.currentProcessID).subscribe(
			resp => this.translateMsg(format, resp),
			err => this.onError(err),
			() => this.onFinish()
		)
	}

	onError(err) {
		this._viewService.errorAlert(err);
		this.onCancel();
	}

	onFinish() {
		this.currentProcessID = '';
		if (this.busy !== undefined && this.busy !== null) {
			this.busy.unsubscribe();
			this.busy = null;
		}
		this._viewService.isSelecting = false;
		this._viewService.enableUI = true;
	}

	onSave() {
		let file = new Blob([(this.outputFormat === 'json') ?
			JSON.stringify(this.export_result) : this.export_result], { type: 'text;charset=utf-8' });
		saveAs(file, this.collection.name + '.' + this.outputFormat);
	}

	translateMsg(format, msg) {
		let msgObj = JSON.parse(msg.data);
		let msgText = this.b64DecodeUnicode(msgObj.data); // atob(msgObj.data);
		switch (msgObj.type) {
			case '_info':
				this.progress = msgText;
				break;
			case '_finish':
				this.onFinish();
				break;
			case '_error':
				this.onError(msgText);
				break;
			case '_':
				this.updateResult(format, msgText);
				break;
		}
	}

	b64DecodeUnicode(str) {
		// Going backwards: from bytestream, to percent-encoding, to original string.
		return decodeURIComponent(atob(str).split('').map(function (c) {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));
	}

	updateResult(format: string, resp: string) {
		if (format === 'json') {
			try {
				this.export_result = JSON.parse(resp);
			} catch (e) {
				this.onError(e);
				console.log(resp);
			}
		} else {
			this.export_result = resp;
		}
		if (format === 'csv' || format === 'xlsx') {
			if (this.collection == null) {
				this._viewService.errorAlert(this.collection.name + ' not found!');
				return;
			}
			let preview = (format === 'csv') ? this.csv_preview : this.xls_preview;
			preview.fieldMask = [];
			preview.header = [];
			this.initColumns(preview, this.collection);
			try {
				preview.displayData(this.export_result, this._httpService.baseUrl);
			} catch (err) {
				this._viewService.errorAlert(err);
			}
		}
	}

	getExportResult(): string {
		return (this.outputFormat === 'json') ? JSON.stringify(this.export_result) : this.export_result;
	}

	ngOnDestroy() {
		this.resultLinkSubscription.unsubscribe();
		this.progressSubscription.unsubscribe();
	}

	onCancel() {
		if (this.currentProcessID !== '') {
			this._httpService.sendCancelRequest(this.currentProcessID).subscribe();
		}
		this.onFinish();
	}

	private initColumns(view: any, collection: Collection): void {
		for (let selector of collection.fields) {
			if (selector.attrs.indexOf('path') >= 0) {
				this.initColumns(view, selector.details)
				break;
			}
			view.header.push(selector.name);
		}
	}

	private onChangeFormat(format: string) {
		this.outputFormat = format;
		this.resultLink = '';
	}

	private onCreateTask() {
		let task = '{"type":"extract","payload":' + this.collection.stringify(this.collection.format, this.collection.name) +
			',"name":"' + this.collection.name + '"}';
		this._httpService.createTask(task).subscribe(
			response => window.open(this.dashboardURL),
			error => this._viewService.errorAlert(error)
		);
	}

	userExists(): boolean {
		return DFK.User.exists();
	}
}
